import { useMemo } from 'react';
import { IconLogout, IconReceipt, IconUser } from '@tabler/icons-react';
import { Avatar, Menu } from '@mantine/core';
import { useLogout } from '@/src/modules/auth/hooks/use-logout';
import { useAuthStore } from '@/src/modules/auth/stores/use-auth-store';
import { ETransactionStatus } from '@/src/modules/transaction/enums/transactionStatus';

export function UserAvatarMenu() {
  const { trigger: logout, isLoading: isLoggingOut } = useLogout();
  const user = useAuthStore((state) => state.user);
  const individual = useAuthStore((state) => state.individual);

  const image = useMemo(() => {
    return individual?.props.profileImage;
  }, [individual?.props]);

  return (
    <Menu withArrow shadow="md" width="12rem">
      <Menu.Target>
        <Avatar
          src={
            image ||
            `${process.env.NEXT_PUBLIC_STORAGE_BASE_URL}/healthcare-intelligence/Member/Default_Profile_Picture.png`
          }
          radius={999}
          color="brand.5"
          name={user!.fullName}
          size="md"
          className="cursor-pointer"
        />
      </Menu.Target>

      <Menu.Dropdown>
        <Menu.Item
          leftSection={<IconUser size={14} />}
          component="a"
          href="/profile"
        >
          Profile
        </Menu.Item>

        <Menu.Item
          leftSection={<IconReceipt size={14} />}
          component="a"
          href={`/riwayat-belanja?type=${ETransactionStatus.Unpaid}`}
        >
          Pembelian
        </Menu.Item>

        {/* <Menu.Item
          leftSection={<IconSettings size={14} />}
          component="a"
          href="/"
        >
          Pengaturan
        </Menu.Item> */}

        <Menu.Item
          leftSection={<IconLogout size={14} />}
          color="red"
          onClick={() => logout()}
          disabled={isLoggingOut}
        >
          Logout
        </Menu.Item>
      </Menu.Dropdown>
    </Menu>
  );
}
